
















































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Emit, Watch } from 'vue-property-decorator';
import { formatDate } from '@/utils';

@Component({
    components: {}
})
export default class DateRangePickerComponentFullEx extends Vue {
    @Prop() public periods: Array<{ start: Date; end: Date }>;

    public visible: boolean = false;

    get period1() {
        return this.periods && this.periods.length === 2
            ? this.periods[0]
            : null;
    }

    get period2() {
        return this.periods && this.periods.length === 2
            ? this.periods[1]
            : null;
    }

    get linkStr(): string {
        let link: string = '';
        this.periods.map((period) => {
            link += `"${formatDate(period.start)}, ${formatDate(
                period.end
            )}" ~ `;
        });
        return link.substr(0, link.length - 3);
    }


    public period1Change(period1) {
        this.input([period1, this.period2]);
    }

    public period1StartChange(val) {
        this.input([{start: val, end: this.period1.end}, this.period2]);
    }

    public period1EndChange(val) {
        this.input([{start: this.period1.start, end: val}, this.period2]);
    }

    public period2Change(period2) {
        this.input([this.period1, period2]);
    }

    public period2StartChange(val) {
        this.input([this.period1, {start: val, end: this.period2.end}]);
    }

    public period2EndChange(val) {
        this.input([this.period1, {start: this.period2.start, end: val}]);
    }


    public toggle() {
        this.visible = !this.visible;
    }

    public select() {
        this.visible = false;
    }

    @Emit()
    public input($val) {
        // raise input
    }
}
